export default __webpack_public_path__ + "static/media/Kaushik Mody.a1c89b6b.jpg";